
export { default as CreateInstitute } from './CreateInstitute';
export { default as EditInstitute } from './EditInstitute';
export { default as ListInstitute } from './ListInstitute';
export { default as Header } from '../Header';
export { default as AdminNavbar } from '../AdminNavbar';
export { default as Adminmain } from '../Adminmain';
